import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../main/left-side';
import Navbar from '../navigation/navbar';
import TurnoverCard from './forms/turnover-card';
import VerticalNavigation from '../navigation/vertical-navigation';

const Turnover = createReactClass({
    displayName: 'Turnover',

    propTypes: {
        strings: PropTypes.object,
    },

    mixins: [],

    componentWillMount() {},

    render() {
        return (
            <Navbar nav>
                <Row>
                    <LeftSide addClass="">
                        <VerticalNavigation selected="turnover" />
                    </LeftSide>
                    <Col xs={9} className="col-middle">
                        <Row>
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <TurnoverCard />
                            </Col>
                        </Row>
                        <Row className="spacer-tb">
                            <Col xs={8}></Col>
                        </Row>
                    </Col>
                </Row>
            </Navbar>
        );
    },
});

export default Turnover;
